import examSchedule from '@/api/exam-schedule'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  main_programs: [],
  sub_programs: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_MAIN_PROGRAMS(state, data) {
    state.main_programs = data
  },
  SET_SUB_PROGRAMS(state, data) {
    state.sub_programs = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return examSchedule.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return examSchedule.store(data)
  },

  async find(context, id) {
    return await examSchedule.find(id)
  },

  update(context, data) {
    return examSchedule.update(data)
  },

  delete(context, data) {
    return examSchedule.destroy(data)
  },

  async dataBeforeCreate(context) {
    let response = await examSchedule.mainProgram()
    context.commit('SET_MAIN_PROGRAMS', response)
  },

  async getSubProgram(context, acp_id) {
    context.commit('SET_SUB_PROGRAMS', [])
    let response = await examSchedule.getSubProgram(acp_id)
    context.commit('SET_SUB_PROGRAMS', response)
  }
}
